export enum Cookies {
  loginId = "loginId",
  authKey = "authKey",
  clientId = "id",
  mainModal = "mainModal",
}